export default __webpack_public_path__ + "static/media/icon3d__design.bd0b9e98.png";